module.exports = __webpack_public_path__ + "static/img/no-message.50345b4.png";